import { render, staticRenderFns } from "./DoctorsListItem.vue?vue&type=template&id=7ef27d90&scoped=true&"
import script from "./DoctorsListItem.vue?vue&type=script&lang=js&"
export * from "./DoctorsListItem.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsListItem.vue?vue&type=style&index=0&id=7ef27d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef27d90",
  null
  
)

export default component.exports